export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/signal-blitz-thumb-32763a76b0c98aded0be3d8f58424452.png";